import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

const STORAGE_KEY = 'preferred-language';
const DEFAULT_LANGUAGE = 'pt-BR';

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Tenta carregar o idioma salvo no localStorage
    const savedLanguage = localStorage.getItem(STORAGE_KEY);
    if (savedLanguage) {
      return savedLanguage;
    }

    // Tenta detectar o idioma do navegador
    const browserLanguage = navigator.language || navigator.userLanguage;

    // Mapeia códigos de idioma do navegador para nossos códigos
    const languageMap = {
      'pt': 'pt-BR',
      'pt-BR': 'pt-BR',
      'pt-PT': 'pt-BR',
      'en': 'en',
      'en-US': 'en',
      'en-GB': 'en',
      'es': 'es',
      'es-ES': 'es',
      'es-MX': 'es',
      'fr': 'fr',
      'fr-FR': 'fr',
      'it': 'it',
      'it-IT': 'it',
      'sv': 'sv',
      'sv-SE': 'sv',
      'no': 'no',
      'nb': 'no',
      'nn': 'no',
      'da': 'da',
      'da-DK': 'da'
    };

    return languageMap[browserLanguage] || DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    // Salva o idioma selecionado no localStorage
    localStorage.setItem(STORAGE_KEY, currentLanguage);
  }, [currentLanguage]);

  const changeLanguage = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
